import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'CHECKLIST_INSTANCES',
    itemActionName: 'CHECKLIST_INSTANCE',
});
